import React from "react";
import "../../css/homeDev.css";
import ListDevs from "./devList";

const DevHome = () => {
  return (
    <div>
      <ListDevs />
    </div>
  );
};
export default DevHome;
